import { Modal } from "antd";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import { useEffect, useState } from "react";
import { pipGetProfile } from "../../utils/pip";
import Loader from "../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../../components/other/NoRecord";
import ReactPagination from "../../layout/ReactPagination";
import PaginationDropdown from "../../layout/PaginationDropdown";
import {
  acceptInvitaion,
  rejectInvitaion,
  fetchClassesInvitations,
} from "../../redux/action/authAction";

const ClassroomInvitations = () => {
  const dispatch = useDispatch();
  const { invitationsList, isLoading } = useSelector(
    (state) => state?.authReducer,
  );
  const [list, setlist] = useState(invitationsList);
  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setPerPageList] = useState(10);
  const [invitation_id, setInvitationId] = useState(null);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [isAcceptModal, setIsAcceptModal] = useState(false);

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  // Get paginated data for the current page
  const paginateOrders = list?.slice(
    currentPage * listPerPages,
    (currentPage + 1) * listPerPages,
  );

  useEffect(() => {
    fetchInvitations();
  }, []);

  useEffect(() => {
    setlist(invitationsList);
  }, [invitationsList]);

  const fetchInvitations = () => {
    const callback = (response) => {
      if (response.success) {
      }
    };
    const user_google_id = pipGetProfile()?.google_id;
    dispatch(
      fetchClassesInvitations({ payload: { user_google_id }, callback }),
    );
  };

  const handleDeleteInvitation = () => {
    const callback = (response) => {
      if (response.success) {
        setIsDeleteModal(false);
        fetchInvitations();
      }
    };

    dispatch(rejectInvitaion({ payload: { invitation_id }, callback }));
  };
  const handleAcceptInvitation = () => {
    const callback = (response) => {
      if (response.success) {
        setIsAcceptModal(false);
        fetchInvitations();
      }
    };

    dispatch(acceptInvitaion({ payload: { invitation_id }, callback }));
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
        <Header />
        <div className="py-5">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="ct_invitation_white_bg">
                  <div className="d-flex align-items-center justify-content-between gap-3 mb-5">
                    <h4 className="text-dark text-center ct_fs_24 ct_fw_600 ">
                      Invitations
                    </h4>
                  </div>
                  <div className="table-responsive">
                    <table className="table ct_add_room_table">
                      <thead>
                        <tr>
                          <th>S. No.</th>
                          <th>Teacher Name</th>
                          <th>Class</th>
                          <th className="text-end">Action</th>
                        </tr>
                      </thead>

                      {paginateOrders?.length > 0 && (
                        <tbody>
                          {paginateOrders?.map((item, index) => (
                            <tr>
                              <td>{index + 1}</td>
                              <td>{item?.invited_by_name ?? ""}</td>
                              <td>{item?.course_name ?? ""}</td>
                              <td className="text-end">
                                <div className="d-flex align-items-center gap-2 justify-content-end">
                                  <button
                                    title="Accept"
                                    className="ct_action_accept "
                                    onClick={() => {
                                      setInvitationId(item?.invitation_id);
                                      setIsAcceptModal(true);
                                    }}
                                  >
                                    <i class="fa-solid fa-check"></i>
                                  </button>
                                  <button
                                    onClick={() => {
                                      setInvitationId(item?.invitation_id);
                                      setIsDeleteModal(true);
                                    }}
                                    title="Reject"
                                    className="ct_action_delete "
                                  >
                                    <i class="fa-solid fa-xmark"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </table>
                    {paginateOrders?.length === 0 && (
                      <NoRecord className="text-center" />
                    )}
                  </div>

                  {list?.length > 10 && (
                    <>
                      <div className="d-flex justify-content-between align-items-center mt-4">
                        <div>
                          <PaginationDropdown
                            onChange={(val) => {
                              setPerPageList(val);
                              setCurrentPage(0);
                            }}
                          />
                        </div>
                        <div>
                          <ReactPagination
                            pageCount={Math.ceil(list?.length / listPerPages)}
                            onPageChange={handlePageClick}
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>

      {/* delete model */}
      <Modal
        centered={true}
        title={``}
        open={isDeleteModal}
        onCancel={() => {
          setIsDeleteModal(false);
        }}
        footer={null}
      >
        <div className="mt-4">
          <div className="modal-body border-0 pt-0">
            <div className="text-center mb-3">
              <img
                src="img/warning.png"
                alt=""
                className="mx-auto"
                style={{ maxWidth: "80px" }}
              />
            </div>
            <h4 className="ct_fs_28 ct_fw_600 text-center mb-4">
              Reject Invitation
            </h4>
            <p className="text-center mb-4 ct_fs_18">
              Are you sure you want to reject the invitation to join the Google
              Classroom?
            </p>
          </div>

          <div className="d-flex align-items-center gap-4 justify-content-center ct_flex_column_575 ">
            <a
              href="javascript:void(0)"
              type="button"
              className="bg-danger ct_single_cart_btn ct_btn_animate ghost ct_black_animation_btn"
              style={{ borderColor: "rgb(220, 53, 69)" }}
              onClick={handleDeleteInvitation}
            >
              Ok
            </a>
            <button
              type="button"
              className="ct_single_cart_btn ct_btn_animate ghost ct_black_animation_btn"
              onClick={() => {
                setIsDeleteModal(false);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>

      {/* accept model */}
      <Modal
        centered={true}
        title={``}
        open={isAcceptModal}
        onCancel={() => {
          setIsAcceptModal(false);
        }}
        footer={null}
      >
        <div className="mt-4">
          <div className="modal-body border-0 pt-0">
            <div className="text-center mb-3">
              <img
                src="img/warning.png"
                alt=""
                className="mx-auto"
                style={{ maxWidth: "80px" }}
              />
            </div>
            <h4 className="ct_fs_28 ct_fw_600 text-center mb-4">
              Accept Invitation
            </h4>
            <p className="text-center mb-4 ct_fs_18">
              Are you sure you want to accept the invitation to join the Google
              Classroom?
            </p>
          </div>

          <div className="d-flex align-items-center gap-4 justify-content-center ct_flex_column_575 ">
            <a
              href="javascript:void(0)"
              type="button"
              className="bg-danger ct_single_cart_btn ct_btn_animate ghost ct_black_animation_btn"
              style={{ borderColor: "rgb(220, 53, 69)" }}
              onClick={handleAcceptInvitation}
            >
              Ok
            </a>
            <button
              type="button"
              className="ct_single_cart_btn ct_btn_animate ghost ct_black_animation_btn"
              onClick={() => {
                setIsAcceptModal(false);
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ClassroomInvitations;
